import React, { lazy } from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  image: 'https://cdn.magicpatterns.com/uploads/5P7tX449Uk5Cuygh4GPuXR/1_475b83d3-bb40-4f0c-b9a5-e4b986757e23.webp',
  name: 'María González',
  location: 'Buenos Aires, Argentina',
  rating: 5,
  text: 'Hice las empanadas sin gluten y quedaron increíbles. Mi familia no podía creer que eran sin harina de trigo.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/qb3ZAddJFpViF7wzzvP2Xg/3_ef11b9bb-1bd3-437d-9320-cfcb45142a56.webp',
  name: 'Carolina Méndez',
  location: 'Bogotá, Colombia',
  rating: 5,
  text: 'El pan artesanal me salió perfecto desde el primer intento. Crujiente por fuera, suave por dentro. ¡Increíble!'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/p7u5uHttKxe9fT6udxDS3Y/4.webp',
  name: 'Laura Rodríguez',
  location: 'Ciudad de México, México',
  rating: 5,
  text: 'Las facturas sin gluten fueron un éxito total en mi casa. Mis hijos las aman y yo cocino sin culpa.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/ux2ZzNRJkCkPqzHsEEzWcz/13.webp',
  name: 'Ana Martínez',
  location: 'Santiago, Chile',
  rating: 5,
  text: 'Soy diabética y este pan no me sube el azúcar. Por fin puedo desayunar con pan de verdad. ¡Gracias!'
}];
function Stars({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-0.5" data-id="element-204">
      {Array.from({
      length: count
    }).map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-[#FBBF24] text-[#FBBF24]" data-id="element-205" />)}
    </div>;
}
export function TestimonialSection() {
  return <section className="py-14 px-4 bg-[#FFFBF0] pt-[3px] pb-[3px]" data-id="element-206">
      <div className="max-w-2xl mx-auto" data-id="element-207">
        {/* Top Label */}
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.2em] text-[#D9A441] mb-4" data-id="element-208">
          ★ Reseñas Verificadas
        </p>

        {/* Main Headline */}
        <h2 className="text-center text-[22px] md:text-[28px] font-black text-gray-900 font-[Merriweather,_serif] leading-tight mb-3" data-id="element-209">
          Lo que dicen nuestros <span className="text-[#D9A441]" data-id="element-210">clientes</span>
        </h2>

        {/* Supporting Text */}
        <p className="text-center text-gray-500 text-sm md:text-base mb-5 max-w-md mx-auto" data-id="element-211">
          Personas reales que transformaron su cocina con nuestras recetas sin
          gluten
        </p>

        {/* Rating Badge */}
        <div className="flex items-center justify-center gap-2 mb-8" data-id="element-212">
          <div className="flex gap-0.5" data-id="element-213">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-[#FBBF24] text-[#FBBF24]" data-id="element-214" />)}
          </div>
          <span className="text-sm font-bold text-gray-800" data-id="element-215">4.9/5</span>
          <span className="text-xs text-gray-400 font-medium" data-id="element-216">
            — 2,400+ opiniones
          </span>
        </div>

        {/* Testimonial Grid */}
        <div className="grid grid-cols-2 gap-3 md:gap-4" data-id="element-217">
          {testimonials.map((t, index) => <div key={index} className="bg-white rounded-xl border border-[#F0EBE0] overflow-hidden shadow-[0_2px_12px_rgba(0,0,0,0.04)]" data-id="element-218">
              {/* Image */}
              <div className="aspect-square overflow-hidden" data-id="element-219">
                <img src={t.image} alt={`Resultado de ${t.name}`} className="w-full h-full object-cover" loading="lazy" data-id="element-220" />
              </div>

              {/* Content */}
              <div className="p-3 md:p-4" data-id="element-221">
                <Stars count={t.rating} data-id="element-222" />
                <p className="text-gray-700 text-[12px] md:text-[13px] leading-snug mt-2 mb-3" data-id="element-223">
                  "{t.text}"
                </p>
                <div className="border-t border-gray-100 pt-2" data-id="element-224">
                  <p className="text-[12px] font-bold text-gray-900" data-id="element-225">
                    {t.name}
                  </p>
                  <div className="flex items-center gap-1 mt-0.5" data-id="element-226">
                    <span className="text-[10px] text-gray-400" data-id="element-227">
                      {t.location}
                    </span>
                    <span className="text-[10px] text-green-500 font-semibold flex items-center gap-0.5" data-id="element-228">
                      ✓ Verificada
                    </span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}